<template>
    <div class="gofixInput gofixDropdownInput gofixDropdownTree" v-bind:class="{gofixInputHasDesc:desc,gofixInputError : (required && !value && blurInput),gofixInputDisable:disabled}">
        <div class="mainInput">
            <tree-select
                :default-expand-level="defaultExpandLevel"
                :multiple="multiple"
                :options="options"
                :load-options="loadOptions"
                :search-nested="searchNested"
                :value="value"
                :normalizer="normalizer"
                :valueFormat="valueFormat"
                :searchable="searchable"
                :openOnClick="openOnClick"
                :openOnFocus="openOnFocus"
                :noResultsText="noResultsText"
                :noChildrenText="noChildrenText"
                :disable-branch-nodes="disableBranchNodes"
                :clearable="clearable"
                :disabled="disabled"
                :alwaysOpen="alwaysOpen"
                placeholder=""
                @input="handleInput"
                @close="blurInput = true"
                @deselect="blurInput = true"
                @select="handleSelect"
                :flat="flat"
            >
              <template #value-label="option" v-if="userValueLabelSlot">
                <slot name="gofixTreeSelect:value-label" v-bind="option"></slot>
              </template>
            </tree-select>
            <div class="label">{{label}}<span class="iconRequired" v-if="showIconRequired && required">*</span></div>
        </div>
        <p class="desc" v-if="desc" v-html="desc"></p>
    </div>
</template>

<script>
    import treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.min.css';
    export default {
        name: "dropdown-supplier",
        components: {
            'tree-select': treeselect
        },
        props: {
            label: {
                type: String,
                required: false,
                default: () => "Select tree"
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },
            value: {
                required: true,
                default: () => null
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            desc: {
                type: String,
                required: false,
                default: () => null
            },
            options: {
                type: Array,
                required: true,
                default: () => []
            },
            defaultExpandLevel: {
                type: Number,
                required: false,
                default: () => 1
            },
            disableBranchNodes: {
                type: Boolean,
                required: false,
                default: () => false
            },
            clearable: {
                type: Boolean,
                required: false,
                default: () => true
            },
            loadOptions: {
                type: Function,
                required: false,
                default: () => null
            },
            normalizer: {
                type: Function,
                required: false,
                default: (node) => node
            },
            multiple: {
                type: Boolean,
                required: false,
                default: () => false
            },
            searchNested: {
                type: Boolean,
                required: false,
                default: () => false
            },
            searchable: {
                type: Boolean,
                required: false,
                default: () => true
            },
            openOnClick: {
                type: Boolean,
                required: false,
                default: () => true
            },
            openOnFocus: {
                type: Boolean,
                required: false,
                default: () => false
            },
            valueFormat: {
                type: String,
                required: false,
                default: () => "id"
            },
            noResultsText: {
                type: String,
                required: false,
                default: () => "No results found..."
            },
            noChildrenText: {
                type: String,
                required: false,
                default: () => "No sub-options."
            },
            disabled: {
                type: Boolean,
                default: false
            },
            alwaysOpen: {
                type: Boolean,
                default: false
            },
            userValueLabelSlot: {
                type: Boolean,
                default: false
            },
            flat: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                blurInput: false,
            }
        },
        watch: {


        },
        created(){

        },
        methods: {
            handleInput (e) {
                this.$emit("input", e);
                this.$emit("change", e);
            },
            handleSelect(e) {
                this.$emit("select", e);
            }
        }
    }
</script>

<style scoped>

</style>
